export default __webpack_public_path__ + "static/media/double-line-blackboard.2a64e712.png";